<template>
  <div class="error flexcenter">
    <transition>
      <div class="err flexcenter">
        <div v-if="buttonKind === 'login'">
          <div v-if="isEnvironmentPc()" class="modal-title">
            <p>再度サインインしてください。</p>
            <p>改善しない場合は、<a href="https://www.sourcenext.com/support/qa/?faq=RS-09396" target="_blank">サポートページ</a>をご覧ください。</p>
          </div>
          <div v-else class="modal-title">再度サインインしてください</div>
        </div>
        <div v-else>
          <div class="modal-title">{{ message }}</div>
        </div>

        <div class="align-center" v-if="buttonKind === 'login'">
          <!-- ログイン -->
          <button class="login" type="button" v-on:click="goLogin">サインインする</button>
        </div>
        <div class="align-center" v-else-if="buttonKind === 'serial'">
          <!-- シリアル入力 -->
          <button class="serial" type="button" v-on:click="goSerial">シリアル入力画面</button>
        </div>
        <div class="align-center" v-else-if="buttonKind === 'library'">
          <!-- ライブラリへ戻る -->
          <button class="serial" type="button" v-on:click="goLibrary">ライブラリへ戻る</button>
        </div>
        <div class="align-center" v-else-if="buttonKind === 'close'">
          <button type="button" v-on:click="$emit('close')">閉じる</button>
        </div>
        <div class="flexbox" v-else>
          <!-- 再実行 -->
          <button class="retry" type="button" v-on:click="retry">再実行</button>
          <!-- キャンセル -->
          <button class="cancel" type="button" v-on:click="cancel">キャンセル</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common'

export default {
  name: 'error',
  props: {
    message: String,
    buttonKind: String,
    isDocomo: Boolean,
    productInfo: Object
  },
  mixins: [
    common,
  ],
  methods: {
    /**
     * ログイン画面へ遷移
     */
    goLogin: function() {
      // ドコモ版Androidアプリかを判定
      if(this.isDocomo) {
        // ドコモ認証を行う
        window.Phone.DoAuth();
      } else {
        // ログイン画面へ遷移
        window.location.assign(this.makeLoginURL())
      }
    },
    /**
     * ログイン画面のURLを作成する
     */
    makeLoginURL: function() {
      var contentID = this.productInfo.code
      var url = process.env.LIBRARY_URL + "login?id=" + contentID
      return url
    },
    /**
     * シリアル入力画面へ遷移
     */
    goSerial: function() {
      window.location.assign(this.makeSerialURL())
    },
    /**
     * シリアル入力画面のURLを作成する
     */
    makeSerialURL: function() {
      var contentID = this.productInfo.code
      var url = process.env.LIBRARY_URL + "activate?id=" + contentID
      return url
    },
    /**
     * ライブラリへ戻る
     */
    goLibrary: function() {
      window.location.assign(process.env.LIBRARY_URL)
    },
    /**
     * 再実行
     */
    retry: function() {
      this.$emit('retry')
    },
    /**
     * ブラウザを閉じる
     */
    cancel: function() {
      window.open('about:blank','_self').close()
    }
  },
  mounted: function() {
    this.log("Error start mounted")
    this.setBodyStylePosition(true)
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Error.vue?4c57db0a